"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_options_core_1 = require("owa-options-core");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function isConversationsOptionDirty(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    var listViewTypeSelected = owa_options_core_1.getFallbackValueIfNull(optionState.globalListViewType, userOptions.GlobalListViewTypeReact);
    var conversationSortOrder = owa_options_core_1.getFallbackValueIfNull(optionState.conversationSortOrder, userOptions.ConversationSortOrderReact);
    var hideDeletedItems = owa_options_core_1.getFallbackValueIfNull(optionState.hideDeletedItems, userOptions.HideDeletedItems);
    return (listViewTypeSelected !== userOptions.GlobalListViewTypeReact ||
        conversationSortOrder !== userOptions.ConversationSortOrderReact ||
        hideDeletedItems !== userOptions.HideDeletedItems);
});
//# sourceMappingURL=isConversationsOptionDirty.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-conversations-option/lib/utils/isConversationsOptionDirty.js
// module id = 5078
// module chunks = 2